/** Keep return destinations inside this service, including query strings. */
export function authNext(value: unknown): string | null {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || value.includes("\\") || Array.from(value).some(char => char.charCodeAt(0) <= 32)) return null;
  try {
    const path = new URL(value, window.location.origin);
    if (path.origin !== window.location.origin || /^\/(login|signup|find-account|forgot)(?:[/?#]|$)/.test(path.pathname)) return null;
    return `${path.pathname}${path.search}${path.hash}`;
  } catch { return null; }
}

export function authLink(path: string, next: string | null) {
  return next ? `${path}?next=${encodeURIComponent(next)}` : path;
}
